<template>
  <div class="lfs-map" id="app" data-app="true">


    <div class="lfs-map-preloader" v-if="loadingMap">

      <div class="lfs-map-preloader-background"></div>
      <v-progress-circular
        :size="200"
        :width="7"
        color="#2D9CDB"
        indeterminate
      ></v-progress-circular>
    </div>


    <snack-bar></snack-bar>

    <maps-prop
      v-if="canvas"
      :stands="stands"
      :zoom="getZ"
      :layout="currentMode !=='polyline' ? canvas.getActiveObjects() : []"
      :tool="typeAction"
      :folder="layoutsGroup[currentLayoutCroupIndex]"
      :currentLayoutCroupIndex="currentLayoutCroupIndex"
      :props="props"
      :exhibition="$route.params.code"
      @changeProp="(prop) => changeProp(prop)"
      @deleteLayout="deleteLayout()"
      @copyLayout="copyLayout()"
      @upLayout="upLayout()"
      @changeScaleDef="changeZoomdEF()"
      @downLayout="downLayout()"
      @downFolder="(folder)=>downFolder(folder)"
      @upFolder="(folder)=>upFolder(folder)"
      @hideZoomEvent="(item)=>hideZoomEvent(item)"
      @changeNameFolder="(item)=>changeNameFolder(item)"
      @changeNameObject="(item)=>changeNameObject(item)"
      @changeZoom="(bool)=>changeZoom(bool)"
    />
    <div class="lfs-map-sidebar">

      <maps-sidebar-header :layout="$route.params.code"/>
      <maps-sidebar-tools
        @createStandTemplate="(stand)=>createStandTemplate(stand)"
        @addLayout="addLayout()"
        @setCurrentMode="(type)=>this.setCurrentMode(type)"
        @selectMode="(type)=>setCurrentMode(type)"
        :propCurrentMode="currentMode "
        :tool="tool"
        :stands="getStands"
        @clickChangeTool="(tool, prop) => addCanvasElement(tool,prop)"
        @clickChangeToolText="(type, props) => clickChangeToolText(type,props)"
        @clickAddPreset="(item)=>clickAddPreset(item)"
        @clickAddPresetSvg="(item)=>clickAddPresetSvg(item)"
      />
      <maps-sidebar-layouts
        v-if="canvas"
        @selectFolder="(item)=>selectFolder(item)"
        @changeActiveObjects="(item)=>changeActiveObjects(item)"
        @showElement="(id)=>setVisibleObject(id)"
        @lockElement="(id)=>setLockObject(id)"
        @lockLayout="(index)=>lockLayout(index)"
        @showLayout="(index)=>showLayout(index)"
        @changeActive="(id)=>changeActiveEl(id)"
        :zoom="canvas.getZoom()"
        :items="itemsLayout"
        :layouts="layouts"
        :currentLayoutCroupIndex="currentLayoutCroupIndex"
        :layoutsGroup="layoutsGroup"
      />
      <maps-sidebar-buttons @save="saveCanvasJSONByServer()" />
      <!--      <maps-sidebar-navigation @selectMode="(type)=>setCurrentMode(type)"/>-->
    </div>
    <div id="lfs-map-content" class="lfs-map-content">
      <div id="" @wheel.prevent="wheel">
        <canvas id="canvas"></canvas>
      </div>
    </div>
    </div>

</template>

<script>
import {fabric} from 'fabric'
import MapsProp from "@/components/lfs/Map/MapsProp";
import MapsContent from "@/components/lfs/Map/MapsContent";
import MapsSidebarHeader from "@/components/lfs/Map/MapsSidebarHeader";
import MapsSidebarTools from "@/components/lfs/Map/MapsSidebarTools";
import MapsSidebarLayouts from "@/components/lfs/Map/MapsSidebarLayouts";
import MapsSidebarNavigation from "@/components/lfs/Map/MapsSidebarNavigation";
import MapsSidebarButtons from "@/components/lfs/Map/MapsSidebarButtons";
import {zoomMixin} from "@/components/Canvas/Mixin/zoom";
import {activeMix} from "@/components/Canvas/Mixin/selected";
import {eventsMix} from "@/components/Canvas/Mixin/events";
import {canvasMix} from "@/components/Canvas/Mixin/canvas";
import {elementsMix} from "@/components/Canvas/Mixin/elements";
import {propsMix} from "@/components/Canvas/Mixin/props";
import {layoutsMix} from "@/components/Canvas/Mixin/layouts";
import {modesMix} from "@/components/Canvas/Mixin/modes";
import axios from "axios";
import {mapGetters, mapMutations} from "vuex";
import SnackBar from '@/components/UI/SnackBar.vue';



export default {
  name: "MapTest",
  components: {SnackBar,MapsProp, MapsContent, MapsSidebarHeader, MapsSidebarTools, MapsSidebarLayouts, MapsSidebarNavigation, MapsSidebarButtons},
  mixins: [
    elementsMix,
    canvasMix,
    modesMix,
    activeMix,
    eventsMix,
    propsMix,
    layoutsMix,
    zoomMixin,

  ],
  data() {
    return {
      loadingMap:true,
      shape: '',
      stands: [],
      tool: 'curve',
      testI: 1,
      ObjectCanvas: [],
      currentPolyLine: null,
      currentLayoutCroupIndex: 0,
      layoutsGroupDef: [
        {
          slug:'roof',
          name: 'крыша',
          lock: false,
          show: true,
          active: true,
          objects: [],
          event: {
            type: 'none',
            value: 0
          }
        },
        {
          slug:'hall',
          name: 'залы',
          lock: false,
          show: true,
          active: true,
          objects: [],
          event: {
            type: 'none',
            value: 0
          }
        },
        {
          slug:'logo',
          name: 'логотипы',
          lock: false,
          show: true,
          active: true,
          objects: [],
          event: {
            type: 'none',
            value: 0
          }
        },
        {
          slug:'company',
          name: 'компании',
          lock: false,
          show: true,
          active: true,
          objects: [],
          event: {
            type: 'none',
            value: 0
          }
        },
        {
          slug:'stand',
          name: 'стенды',
          lock: false,
          show: true,
          active: true,
          objects: [],
          event: {
            type: 'none',
            value: 0
          }
        },
        {
          slug:'icon',
          name: 'иконки',
          lock: false,
          show: true,
          active: true,
          objects: [],
          event: {
            type: 'none',
            value: 0
          }
        },

        {
          slug:'floor',
          name: 'пол/стены ...',
          lock: false,
          show: true,
          active: true,
          objects: [],
          event: {
            type: 'none',
            value: 0
          }
        },
        {
          slug: 'sources',
          name: 'исходники',
          lock: false,
          show: true,
          active: true,
          objects: [],
          event: {
            type: 'исходники',
            value: 0
          }
        }
      ],
      layoutsGroup: [
        {
          slug:'roof',
          name: 'крыша',
          lock: false,
          show: true,
          active: true,
          objects: [],
          event: {
            type: 'none',
            value: 0
          }
        },
        {
          slug:'hall',
          name: 'залы',
          lock: false,
          show: true,
          active: true,
          objects: [],
          event: {
            type: 'none',
            value: 0
          }
        },
        {
          slug:'logo',
          name: 'логотипы',
          lock: false,
          show: true,
          active: true,
          objects: [],
          event: {
            type: 'none',
            value: 0
          }
        },
        {
          slug:'company',
          name: 'компании',
          lock: false,
          show: true,
          active: true,
          objects: [],
          event: {
            type: 'none',
            value: 0
          }
        },
        {
          slug:'stand',
          name: 'стенды',
          lock: false,
          show: true,
          active: true,
          objects: [],
          event: {
            type: 'none',
            value: 0
          }
        },
        {
          slug:'icon',
          name: 'иконки',
          lock: false,
          show: true,
          active: true,
          objects: [],
          event: {
            type: 'none',
            value: 0
          }
        },

        {
          slug:'floor',
          name: 'пол/стены ...',
          lock: false,
          show: true,
          active: true,
          objects: [],
          event: {
            type: 'none',
            value: 0
          }
        },
        {
          slug: 'sources',
          name: 'исходники',
          lock: false,
          show: true,
          active: true,
          objects: [],
          event: {
            type: 'исходники',
            value: 0
          }
        }
      ],
      canvasSaveOptions:[
        'text','isIcon','standId', 'isCompanyName','isResized','isStand','isStandTitle',
        'id','objectCaching', 'noScaleCache', 'strokeUniform', 'event', 'index','noScaleCache','strokeUniform','subTargetCheck',
        'hasBorders', 'hasControls', 'lockMovementY', 'lockMovementX', 'lockRotation', 'selectable','selection'
      ]
    }
  },
  computed: {
    getStands() {
      if (this.canvas) {
        let checkStands = this.canvas.getObjects()
        let check = checkStands.map((el) => {
          return el.event ? el.event.value : ''
        })
        this.stands.map((elm) => {
          if (check.includes(elm.title)) {
            elm.check = true
          } else {
            elm.check = false
          }
        })

      }
      return this.stands
    },
    ...mapGetters({ show: 'events/show' }),
    getZ() {
      return Math.trunc(this.canvas.getZoom() * 100)
    }
  },
  methods: {
    ...mapMutations("alerts",["setAlert"]),
    async loadMap() {
        this.layoutsGroup.forEach((el)=>{
          el.objects = []
        })
        const data1 = await axios.get('/v4/show/' + this.$route.params.code + '/stands?expand=companyObjects')
        this.stands = data1.data.models.map((el) => {
          el.check = false
          return el
        })
        const data = await this.getCanvasJSONFromServer()
        this.canvas.clear()
        if(data.body){
          this.canvas.loadFromJSON(data.body,()=>{
            this.loadingMap = false

          })
        } else {
          this.loadingMap = false
        }
        if (data.layouts.length !== 0) {
          this.layoutsGroup = data.layouts
        }
    },
    setCurrentLayoutCroupIndex(index) {
      this.currentLayoutCroupIndex = index
    },
    getCanvasJSONFromServer() {
      return axios
        .get('/v4/show/' + this.$route.params.code + '/interactive-map')
        .then((resp) => {
          return resp.data.data
        })
        .catch((error) => {
          console.log('code', error.response.status)
          console.log('msg', error.response.data.error)
          return false
        })
    },
    setLayout() {
      this.canvas.getObjects().map((element) => {
        this.itemsLayout.push([element.type, "circle", "circle", true, false, false, element.id])
      })
    },
    async saveCanvasNullJSONByServer() {
      // console.log(this.layoutsGroup);
      // const lays = this.layoutsGroup.map((el)=>{
      //   el.objects = []
      //   return el
      // })
      const json = {
        "body": '',
        "layouts": this.layoutsGroupDef,
        "mapView": ''
      }
      this.loadingMap = true
      axios
        .post('/v4/show/' + this.$route.params.code + '/interactive-map', json)
        .then(() => {
          this.loadMap()
          this.canvas.renderAll()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    setMapView(res) {
      let jsonData = JSON.stringify(this.canvas.toObject(
       this.canvasSaveOptions
      ))
      const json = {
        "body": jsonData,
        "layouts": this.layoutsGroup,
        "mapView": res
      }
      axios
        .post('/v4/show/' + this.$route.params.code + '/interactive-map', json)
        .then(() => {
          this.setAlert({
            show: true,
            color: 'blue',
            messages: ['Карта сохранена']
          })
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async saveCanvasJSONByServer() {
      console.log('save map')
      const index = this.layoutsGroup.findIndex((el) => {return el.slug == 'sources'})
      let canvasView = new fabric.Canvas('canvasView', { // создаем новый canvasView
        width: this.canvasWidth,
        height: this.canvasHeight,
        selection: false
      });
      console.log(canvasView)

      let help = this.canvas.toObject(
        this.canvasSaveOptions
      )
      console.log('helpStart',help)
      const help2 = help.objects.filter((el) => {
        if (el.visible && el.index !== index)  return el
      })
      help.objects = help2
      console.log('help',help)

      let arrG = []
      let layoutsGroup = [...this.layoutsGroup]
      let res
      let run = this.setMapView

      const vv = await canvasView.loadFromJSON(JSON.stringify(help), callback);
      function callback() {
        canvasView.renderAll()
        layoutsGroup.map((el, i) => {
          if ( el.slug !=='sources' && el.objects.length > 0 && el.objects.filter(el => el[1] !== false).length > 0 ) {
            let group = new fabric.Group()
            group.set('slugGroup', el.slug)
            group.set('title', i + ' группа')
            group.set('event', el.event)
            group.set('subTargetCheck', true)
            group.set('objectCaching', false)
            group.set('selectable', false)
            let srH = [...el.objects]
            srH.reverse().map((el) => {
              if (el[1]) {
                let objClone = canvasView.getObjects().filter(elem => elem.id === el[4])[0]
                group.addWithUpdate(objClone)
                canvasView.remove(objClone)
              }
            })
            arrG.push(group)
          }else {
            let srH = [...el.objects]
            srH.map((el) => {
                let objClone = canvasView.getObjects().filter(elem => elem.id === el[4])[0]
                canvasView.remove(objClone)
            })
          }
        })
        if(arrG.length>0){
          arrG.map((el) => {
            if (el._objects.length > 0) {
              canvasView.add(el)
            }
          })
        }

        res = JSON.stringify(canvasView.toObject(
          [
            'slugGroup','text','isIcon','standId', 'isCompanyName','isResized','isStand','isStandTitle',
            'id','objectCaching', 'noScaleCache', 'strokeUniform', 'event', 'index','noScaleCache','strokeUniform','subTargetCheck',
            'hasBorders', 'hasControls', 'lockMovementY', 'lockMovementX', 'lockRotation', 'selectable','selection'
          ]
        ))

        run(res)
      }
    },
    changeZoom(bool) {
      if (bool) {
        this.canvas.setZoom(this.canvas.getZoom() + 0.5)
      } else {
        this.canvas.setZoom(this.canvas.getZoom() - 0.5)
      }
      this.canvas.zoomToPoint({x: 0, y: 0}, this.canvas.getZoom());
    },
    changeZoomdEF() {
      this.canvas.zoomToPoint({x: 0, y: 0}, 1);
    },
    changeTool(tool, shape = '') {
      this.tool = tool
      this.shape = shape
    },
    setSelectionElementCanvas(bool) {
      this.canvas.forEachObject(function (o) {
        if (o.name !== 'holst') {
          o.hasBorders = o.hasControls = bool;
        }
      });
    },
  },
   created() {
    this.loadMap()
  }
}
</script>

<style lang="scss">

.lfs-map-preloader {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;

  &-background {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #FFFFFF;
  }
}

#buildZone {
  display: flex;
}

.canvas-container, #canvas {
  transition: all 0.2 ease-in-out;
}

#canvas {
  background: rgba(248, 246, 246, 0.24);
  border-radius: 5px;

}

.lfs-map-content {
  background-image: url('/map/background.png');
  background-repeat: repeat;
  height: 100vh;
  width: 100vw;
  padding: 64px 0 0 320px;
  overflow: hidden;
}

.lfs-map {
  font-family: 'Inter', sans-serif !important;

  &-border {
    height: 1px;
    background: #E6E4EA;
    width: calc(100% - 34px);
    margin: 0 19px 0 14px;
  }

  &-sidebar {
    width: 320px;
    height: 100%;
    background: #F3F2F7;
    position: fixed;
    left: 0;
  }

  &-modal {
    filter: drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.3));
    border-radius: 8px;
    background: #F3F2F7;
    position: absolute;
    left: 0;
    top: 50px;
    z-index: 1;

    &-item {
      padding: 10px 15px;
      cursor: pointer;
      display: flex;
      align-items: center;

      &:hover {
        background: #E3F5FF;
      }

      &:first-child:hover {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }

      &:last-child:hover {
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      }

      img {
        margin: 0;
      }

      &-line div {
        width: 42px;
        height: 4px;
        background: #0A0A0A;
      }

      &-title {
        white-space: nowrap;
        font-size: 14px;
        line-height: 17px;
        color: #0A0A0A;
        margin-left: 10px;
        margin-right: 23px;
      }
    }
  }

  &-arrow-down {
    margin-left: 5px;
  }

  .v-tooltip__content {
    display: flex;
    align-items: center;
  }
}

</style>
